import { Link } from "react-router-dom";
import styles from "./SpecialCard.module.css";

export default function SpecialCard({
  variant = "card",
  icon = "",
  title = "",
  description = "",
  href = "",
  index = 0,
}) {
  if (!icon || !title) {
    return null;
  }

  if (variant === "list") {
    return (
      <article className={styles.listCard}>
        <div className={styles.listCardInner}>
          <span className={styles.listIconWrap}>
            <img src={icon} alt={title} className={styles.iconImage} loading="lazy" />
          </span>
          <h3>{title}</h3>
        </div>
      </article>
    );
  }

  if (variant === "service") {
    const serviceVariantClass = styles[`serviceCard${(index % 3) + 1}`];
    const cardContent = (
      <>
        <div className={styles.serviceCardTop}>
          <div className={styles.serviceIconWrap}>
            <img src={icon} alt={title} className={styles.iconImage} loading="lazy" />
          </div>
          <span className={styles.serviceCardIndex}>{String(index + 1).padStart(2, "0")}</span>
        </div>
        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}
      </>
    );

    if (href) {
      return (
        <Link to={href} className={`${styles.serviceCard} ${serviceVariantClass} ${styles.cardLink}`}>
          {cardContent}
        </Link>
      );
    }

    return <article className={`${styles.serviceCard} ${serviceVariantClass}`}>{cardContent}</article>;
  }

  return (
    <article className={styles.specialityCard}>
      <div className={styles.specialityIconWrap}>
        <img src={icon} alt={title} className={styles.iconImage} loading="lazy" />
      </div>
      <h3>{title}</h3>
    </article>
  );
}

export function SpecialCardSection({
  items = [],
  variant = "card",
  eyebrow = "",
  heading = "",
  description = "",
  id,
}) {
  if (!items.length) {
    return null;
  }

  const sectionVariantClass = styles[`section${variant.charAt(0).toUpperCase()}${variant.slice(1)}`];
  const gridVariantClass = styles[`grid${variant.charAt(0).toUpperCase()}${variant.slice(1)}`];

  return (
    <section className={`${styles.section} ${sectionVariantClass || ""}`} id={id}>
      <div className={`container ${styles.shell}`}>
        {(eyebrow || heading || description) && (
          <div className={styles.headingBlock}>
            {eyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
            {heading ? <h2>{heading}</h2> : null}
            {description ? <p>{description}</p> : null}
          </div>
        )}

        <div className={`${styles.grid} ${gridVariantClass || ""}`}>
          {items.map((item, index) => (
            <SpecialCard
              key={item.title || `${variant}-${index}`}
              variant={variant}
              icon={item.icon}
              title={item.title}
              description={item.description}
              href={item.href}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
